import { get } from 'lodash';
function getConsentStatusValue(contact) {
  var status = get(contact, 'consent.state', '').toLowerCase();
  return status;
}
export default getConsentStatusValue;
//# sourceMappingURL=getConsentStatusValue.js.map